export function TooltipCrioId() {
  return (
    <div className="flex flex-col">
      <div className="mb-2">In the CRIO URL, the CRIO ID can be located after '/subject/'</div>
      <div className="mb-2">In the following example, <div className="inline font-bold">99999</div> is the CRIO ID</div>
      <div className="italic">/topography-health/topo-test-site/study/55555/subject/99999</div>
    </div>
  )
}
